import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import SelfServeTooltipTourConstants from 'SelfServeTooltipTour/TooltipTourConstants';
import { ElementWithAnswerFilledTooltip } from './components';

const SelfServeBuilderEditorWithTooltip = ({
  activeTooltipIndex,
  children: selfServeBuilderEditor,
  isTourDisplayed,
}) => {
  const isAnswerFilledTooltipDisplayed = isTourDisplayed &&
  (activeTooltipIndex === SelfServeTooltipTourConstants.ANSWER_FILLED_TOOLTIP_IDX);

  if (isAnswerFilledTooltipDisplayed) {
    return (
      <ElementWithAnswerFilledTooltip
        targetElement={selfServeBuilderEditor}
      />
    );
  }

  return selfServeBuilderEditor;
};

SelfServeBuilderEditorWithTooltip.propTypes = {
  activeTooltipIndex: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  isTourDisplayed: PropTypes.bool.isRequired,
};

const mapStateToProps = ({
  TooltipTourReducer,
}) => ({
  activeTooltipIndex: TooltipTourReducer.activeTooltipIndex,
  isTourDisplayed: TooltipTourReducer.isTourDisplayed,
});

export default ReactRedux.connect(
  mapStateToProps,
)(SelfServeBuilderEditorWithTooltip);



// WEBPACK FOOTER //
// ./src-react/SelfServeRecipientBuilder/SelfServeBuilderEditorWithTooltip.jsx